export enum AssignmentStatus {
    None = 0,
    Draft = 1,
    Live = 2,
}
